var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 19.5L30.5256 15.7046C30.3395 14.216 30.2465 13.4717 29.8961 12.9108C29.5875 12.4166 29.1416 12.023 28.613 11.778C28.013 11.5 27.2629 11.5 25.7626 11.5H16.2374C14.7371 11.5 13.987 11.5 13.387 11.778C12.8584 12.023 12.4125 12.4166 12.1039 12.9108C11.7535 13.4717 11.6605 14.216 11.4744 15.7046L11 19.5M14.5 23.5H27.5M14.5 23.5C12.567 23.5 11 21.933 11 20C11 18.067 12.567 16.5 14.5 16.5H27.5C29.433 16.5 31 18.067 31 20C31 21.933 29.433 23.5 27.5 23.5M14.5 23.5C12.567 23.5 11 25.067 11 27C11 28.933 12.567 30.5 14.5 30.5H27.5C29.433 30.5 31 28.933 31 27C31 25.067 29.433 23.5 27.5 23.5M15 20H15.01M15 27H15.01M21 20H27M21 27H27",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServers);
export default __webpack_public_path__ + "static/media/servers.40e05a4cbb6e547eda3e6ead4672054e.svg";
export { ForwardRef as ReactComponent };